// Helpers
import { apiRequest } from 'helpers/apiClient';

export const convertSelectedFormToPDF = (htmlString, submissionId, accessToken) => dispatch => {
    return apiRequest(`/api/v1/HtmlToPdf/${submissionId}`, {
        method: 'POST',
        accessToken,
        headers: {
            'Content-Type': 'text/html',
            'Accept': 'application/pdf'
        },
        body: htmlString,
        parse: 'none'
    });
}
